import { CalendarDays, Palette, HeartHandshake, LifeBuoy, Network, Users } from "lucide-react";
import { Reveal } from "./Reveal";

const pillars = [
  { icon: CalendarDays, title: "Community Events", body: "Festivals, national-day celebrations, family picnics and iftars that fill the calendar.", testid: "pillar-events" },
  { icon: Palette, title: "Cultural Activities", body: "Dabke, Arabic language, cooking and storytelling that carry heritage to the next generation.", testid: "pillar-culture" },
  { icon: HeartHandshake, title: "Charitable Initiatives", body: "Fundraising and hands-on drives supporting meaningful causes in Australia and Jordan.", testid: "pillar-charity" },
  { icon: LifeBuoy, title: "Social Support", body: "A safety net for new arrivals, students and families navigating life far from home.", testid: "pillar-support" },
  { icon: Network, title: "Networking", body: "Professional circles, mentorship and business connections across the community.", testid: "pillar-networking" },
  { icon: Users, title: "Engagement", body: "Volunteering, youth programs and committees where every voice shapes the Hub.", testid: "pillar-engagement" },
];

export default function Pillars() {
  return (
    <section id="pillars" data-testid="pillars-section" className="border-t border-jordan-ink/15 bg-white/50">
      <div className="mx-auto max-w-[1600px] px-5 py-24 sm:px-10 sm:py-36">
        <Reveal className="mb-16 flex flex-col justify-between gap-8 sm:mb-20 sm:flex-row sm:items-end">
          <div>
            <p className="mb-4 font-display text-xs font-bold uppercase tracking-[0.3em] text-jordan-green">
              What we do · أعمدتنا
            </p>
            <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl">
              Six pillars,<br />one <span className="text-jordan-red">roof</span>
            </h2>
          </div>
          <p className="max-w-sm text-base leading-relaxed text-jordan-mute">
            Everything the Hub does stands on six foundations — each one built by members,
            for members.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 border-l border-t border-jordan-ink/15 sm:grid-cols-2 lg:grid-cols-3">
          {pillars.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.06} className="h-full">
              <div
                data-testid={p.testid}
                className="group flex h-full flex-col justify-between gap-14 border-b border-r border-jordan-ink/15 p-8 transition-colors duration-500 hover:bg-jordan-ink sm:p-10"
              >
                <div className="flex items-start justify-between">
                  <p.icon
                    className="h-8 w-8 text-jordan-red transition-colors duration-500 group-hover:text-jordan-sand"
                    strokeWidth={1.5}
                  />
                  <span className="font-serifx text-2xl italic text-jordan-ink/25 transition-colors duration-500 group-hover:text-jordan-sand/40">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div>
                  <h3 className="mb-3 font-display text-xl font-extrabold uppercase tracking-tight transition-colors duration-500 group-hover:text-jordan-sand sm:text-2xl">
                    {p.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-jordan-mute transition-colors duration-500 group-hover:text-jordan-sand/70 sm:text-base">
                    {p.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
